import { render } from "./Create-new-user.vue?vue&type=template&id=68530444"
import script from "./Create-new-user.vue?vue&type=script&lang=js"
export * from "./Create-new-user.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__